<!--
******************************
 * @author Jesus R. Nava Cruz
 * @date May 24, 2023
 * @version 1.0
******************************
-->
<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="itemsPerPage"
      dense
      no-data-text="Información no disponible"
      fixed-header
      hide-default-footer
    >
      <template v-slot:[`item.status`]="{ index }">
        <div :index="index">
          <Chip
            :pill="true"
            label="Disponible"
            bgColor="green lighten-4"
            txtColor="green"
            classes="font-weight-bold text--darken-4"
          />
          <Chip
            :pill="true"
            label="Ocupado"
            bgColor="red lighten-4"
            txtColor="red"
            classes="font-weight-bold text--darken-4"
          />
        </div>
      </template>

      <template v-slot:[`item.active`]="{ item }">
        <v-switch
          v-model="item.status"
          :false-value="0"
          :true-value="1"
          @change="handleChangeStatus(item)"
        ></v-switch>
      </template>

      <template v-slot:[`item.actions`]="{ item, index }">
        <v-tooltip top :index="index">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="get(item, 3)">
              <v-icon color="warning" v-bind="attrs" v-on="on">
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Editar Espacio</span>
        </v-tooltip>
        <v-tooltip top :index="index">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="handleDeleteItem(item)">
              <v-icon color="error" v-bind="attrs" v-on="on">
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { headersPhysicalSpaces } from "../../../core/HeadersTable";
import Chip from "../../common/Chip.vue";
export default {
  name: "PhysicalSpacesTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    update: Function,
    itemsPerPage: Number,
    listAllPagination: Function,
  },
  components: {
    Chip,
  },
  data: () => ({
    headers: headersPhysicalSpaces,
    dialogCancelation: false,
  }),
  methods: {
    handleDeleteItem(item) {
      this.dialogCancelation = true;
      this.$swal({
        toast: true,
        title: "¿Eliminar espacio físico?",
        text: "",
        icon: "warning",
        confirmButtonText: "Eliminar",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.dialogCancelation = false;
          this.deleteItem(item);
        } else {
          this.dialogCancelation = false;
        }
      });
    },
  },
};
</script>